import { InstagramIcon, SnapchatIcon, TiktokIcon } from '../assets/icons/socials'
import { TrafficSourceCodeEnum } from '../types/traffic-source-code.types'
import type { SegmentedFilterItem } from '../ui-library/components/Filter/SegmentedFilter.types'

export const TRAFFIC_SOURCE_FILTER_ITEMS: SegmentedFilterItem<TrafficSourceCodeEnum>[] = [
  { label: 'Instagram', value: TrafficSourceCodeEnum.Instagram, icon: InstagramIcon },
  { label: 'Snapchat', value: TrafficSourceCodeEnum.Snapchat, icon: SnapchatIcon },
  { label: 'TikTok', value: TrafficSourceCodeEnum.Tiktok, icon: TiktokIcon },
  { label: 'Other', value: TrafficSourceCodeEnum.Other },
]
